const { apiAdapter } = require("./apiAdapter");

const getCategory = () => {
  return apiAdapter({
    url: "public/categories",
    method: "GET",
  });
};

const getProducts = (params, payload) => {
  return apiAdapter({
    url: "public/v2/product/search",
    method: "POST",
    data: payload,
    params,
  });
};
const getProductCatlog = (params, payload) => {
  return apiAdapter({
    url: "public/product/catlog",
    method: "POST",
    data: payload,
    params,
  });
};
const getProductBrands = () => {
  return apiAdapter({
    url: "public/product/brands",
    method: "POST",
  });
};
const getProductInquiry = (data) => {
  return apiAdapter({
    url: "public/product/enquiry",
    method: "POST",
    data,
  });
};
const createProductOrder = (data) => {
  return apiAdapter({
    url: "public/product/order",
    method: "POST",
    data,
  });
};
const getHomeData = () => {
  return apiAdapter({
    url: "public/v2/home",
    method: "GET",
  });
};
const storeNewsletters = (data) => {
  return apiAdapter({
    url: "public/newsletters",
    method: "POST",
    data,
  });
};

module.exports = {
  getCategory,
  getProducts,
  getProductBrands,
  getProductInquiry,
  getHomeData,
  storeNewsletters,
  createProductOrder,
  getProductCatlog,
};
